export class Friend {
  name: string;
  lastName: string;
  age: number;
  email: string;
  gender: string;

  constructor(
    name: string,
    lastName: string,
    age: number,
    email: string,
    gender: string
  ) {
    this.name = name;
    this.lastName = lastName;
    this.age = age;
    this.email = email;
    this.gender = gender;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/friend.ts